<template>
    <main-content-wrapper-team>
        <div v-if="!is_tus_team_only" class="sub-navigation">
            <v-btn @click="openAccount" small text><v-icon class="space-icon">fas fa-arrow-left</v-icon>na spletni račun</v-btn>
        </div>
        <v-tabs fixed-tabs show-arrows v-model="tabs" v-show="!loading">
            <v-tab href="#payroll">
                Plačilne liste
            </v-tab>
            <v-tab href="#security" v-if="is_tus_team_only">
                Varnost
            </v-tab>
        </v-tabs>
        <empty-space />
        <v-tabs-items v-model="tabs" v-show="!loading">
            <v-tab-item value="payroll">
                <PayrollTab />
            </v-tab-item>
            <v-tab-item value="security" v-if="is_tus_team_only">
                <SecurityTab />
            </v-tab-item>
        </v-tabs-items>
    </main-content-wrapper-team>
</template>

<script>
    import MainContentWrapperTeam from "../../components/MainContentWrapperTeam";
    import Router from '../../router';
    import PayrollTab from "../../components/tus-team/PayrollTab";
    import EmptySpace from "../../components/EmptySpace";
    import utils from "../../store/utils";
    import SecurityTab from "../../components/account/SecurityTab";

    export default {
        name: "Team",
        components: {SecurityTab, PayrollTab, MainContentWrapperTeam, EmptySpace},
        data () {
            return {
                tabs: null,
                loading: false
            }
        },
        computed: {
            is_tus_team: utils.vuexBuildSetGet(this, 'auth', 'authenticated_user.is_tus_team'),
            is_tus_team_only: utils.vuexBuildSetGet(this, 'auth', 'authenticated_user.is_tus_team_only'),
        },
        methods: {
            openAccount(){
                Router.push('/racun')
            }
        }
    }
</script>

<style scoped>

    .space-icon{
        margin-right: 10px;
    }

</style>